/**
 * This agent's ROUTE TREE — the screens under its face, declared once.
 *
 * adr/0023 §"An app opens on a subject": the app's URL names the SUBJECT, so
 * the care planner's one screen is `/stays/{id}`. Both surfaces mount this
 * array — App.tsx under the sub-app's own BrowserRouter, and the platform's
 * AgentFrame under Home's pane-local routes — so
 * `care-planner.<tenant>/stays/4711` and the in-frame deep link are the same
 * path and a link works in either place.
 *
 * There is no route for a conversation: it rides as `?c=<id>` because the path
 * names what is on screen, and the conversation is not it. The stay's care plan
 * is a plan in the planner, found by its stay, so the path names the stay.
 *
 * Lazily loaded, and both mount points supply the Suspense boundary. The main
 * app bundles every agent's face, so an eagerly-imported route tree would put
 * this board in every nurse's first paint whether she opens a plan or not.
 */
import { lazy } from 'react'

import type { AgentRoute } from '@frontend/components/agentDetail/agentRoutes'

const Stay = lazy(() => import('./pages/Stay'))

export const routes: AgentRoute[] = [{ path: '/stays/:stayId', element: <Stay /> }]
